export const replaceBRWithNewLine = (text) => text.replace(/<br[ ]?[/]?>/g, '\r\n');
